import { useRoutes } from "react-router-dom";
import { Suspense, useEffect } from "react";
import { locale, addLocale, updateLocaleOptions } from 'primereact/api';
import { ToastContainer } from "react-toastify";

import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'primereact/resources/primereact.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'react-quill/dist/quill.snow.css';
import "./App.css";

import NotFound from "app/pages/error/NotFound";
import { indexRouter } from "app/routers/indexRouter";
import {useAppDispatch, useAppSelector} from "app/store/hook";
import { publicRouter } from "app/routers/publicRouter";
import { HolidayService } from "app/services/common/holidayService";
import { ResponseResultCode } from "app/model/response-api";
import { updateHolidays } from "app/reducers/holidaySlice";
import { CoService } from "app/services/common/CoService";
import { updateBzknd, updateBzkndOnUsers } from "app/reducers/bzkndSlice";
import { getWeather } from "app/reducers/weatherSlice";
import {getMgResources} from "app/reducers/mgResourceSlice";
import { getCommonCode } from "app/reducers/CodeSlice";

export const spinner = (
  <div className="progress-spinner text-center">
    <div className="lds-spinner">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
);

addLocale('ko', {
  firstDayOfWeek: 0,
  'dayNames': ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'],
  'dayNamesShort': ['일', '월', '화', '수', '목', '금', '토'],
  'dayNamesMin': ['일', '월', '화', '수', '목', '금', '토'],
  'monthNames': ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
  'monthNamesShort': ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
  'today': '오늘',
  'clear': '초기화'
});
updateLocaleOptions({ showMonthAfterYear: true }, 'ko');
locale('ko');

function App() {
  const dispatch = useAppDispatch();
  const userInfo = useAppSelector(state => state.userInfo.userInfo);
  const holidays = useAppSelector((state) => state.holidays.holidays);
  const bzknd = useAppSelector(state => state.bzknd.bzknd);
  const bzkndOnUsers = useAppSelector(state => state.bzknd.bzkndOnUsers);
  const todayWeather = useAppSelector(state => state.weather.today);
  const mgResources = useAppSelector(state => state.mgResource.mgResources);
  const coCodes = useAppSelector(state => state.code.code);

  let router = useRoutes([
    ...publicRouter,
    indexRouter,
    { path: "*", element: <NotFound /> },
  ]);

  useEffect(() => {
    if (userInfo) {
      if (holidays == null || holidays.length === 0) {
        HolidayService.getInstance().getHolidays().then(response => {
          if (response?.data && ResponseResultCode.Y === response.resultCode) {
            dispatch(updateHolidays(response.data));
          }
        });
      }

      if (bzknd == null || bzknd.length === 0) {
        CoService.getInstance().getBzkndList().then(response => {
          if (response && ResponseResultCode.Y === response.resultCode) {
            dispatch(updateBzknd(response.data));
          }
        });
      }

      if (bzkndOnUsers == null || bzkndOnUsers.length === 0) {
        CoService.getInstance().getBzkndListOnUsers().then(response => {
          if (response && ResponseResultCode.Y === response.resultCode) {
            dispatch(updateBzkndOnUsers(response.data));
          }
        });
      }

      if (todayWeather == null || todayWeather.length === 0) {
        dispatch(getWeather());
      }

      if (mgResources == null || mgResources.length === 0) {
        dispatch(getMgResources());
      }

      if (coCodes == null || Object.keys(coCodes).length === 0) {
        dispatch(getCommonCode());
      }
    }
  }, [userInfo]);

  return (
    <div>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        pauseOnFocusLoss={false}
        hideProgressBar={false}
        closeOnClick
        limit={3}
      />
      <Suspense fallback={spinner}>{router}</Suspense>
    </div>
  );
}

export default App;
